import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { CoBorrowerFields, emptyCoBorrower } from '@/components/borrower/CoBorrowerFields'
import type { CoBorrowerFormValues } from '@/types/borrower-prescreen-dto'
import { useState } from 'react'

type CoBorrowerPromptProps = {
  onAddCoBorrower: (coBorrower: CoBorrowerFormValues) => Promise<void>
  onContinueAlone: () => Promise<void>
  busy?: boolean
  error?: string | null
}

export function CoBorrowerPrompt({
  onAddCoBorrower,
  onContinueAlone,
  busy,
  error
}: CoBorrowerPromptProps) {
  const [showForm, setShowForm] = useState(false)
  const [coBorrower, setCoBorrower] = useState<CoBorrowerFormValues>(emptyCoBorrower)

  return (
    <div className="space-y-4">
      <Alert>
        <AlertDescription>
          Adding a co-borrower may help you qualify. You can invite a co-borrower to complete their
          portion, or continue with your application alone.
        </AlertDescription>
      </Alert>
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      {!showForm ? (
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button type="button" onClick={() => setShowForm(true)} disabled={busy}>
            Add a co-borrower
          </Button>
          <Button type="button" variant="outline" onClick={() => void onContinueAlone()} disabled={busy}>
            Continue alone
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          <CoBorrowerFields value={coBorrower} onChange={setCoBorrower} disabled={busy} />
          <div className="flex flex-col gap-3 sm:flex-row">
            <Button
              type="button"
              disabled={busy}
              onClick={() => void onAddCoBorrower(coBorrower)}
            >
              Send consent invitation
            </Button>
            <Button type="button" variant="ghost" onClick={() => setShowForm(false)} disabled={busy}>
              Cancel
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
